(function () {
  if (window.location.pathname !== '/apps/gbb/easybundle/79') return;

  var GRIP_IDS = ['8308241629229', '8308243726381'];
  var GRIP_FALLBACK_CENTS = 7900;
  var TOTAL_SELECTOR = '.gbbFooterDiscountedTotalValue';
  var ORIGINAL_CLASS = 'gbbFooterOriginalTotalValue';
  var ORIGINAL_COLOR = '#ff7992';
  var lastWrittenCents = null;
  var lastOriginalCents = null; // pre-our-discount total, used to populate the strikethrough

  var fleshlightData = window.MB_FLESHLIGHT_DATA || [];
  var FLESHLIGHT_IDS = fleshlightData.map(function (p) { return String(p.id); });

  // Seeded from Liquid (USD), overridden with active-currency DOM price when listing renders
  var gripDiscountCents = null;
  var fleshlightPriceCache = {};
  fleshlightData.forEach(function (p) {
    fleshlightPriceCache[String(p.id)] = p.priceCents;
  });

  function getCartProductId(ids) {
    for (var i = 0; i < ids.length; i++) {
      if (document.querySelector('.gbbSlotFooterProductContainer[productid="' + ids[i] + '"]')) {
        return ids[i];
      }
    }
    return null;
  }

  // Handles period-decimal ($1,628.00), comma-decimal (1.628,00), and no-decimal ($79)
  function parseCents(text) {
    var cleaned = text.replace(/[^0-9.,]/g, '');
    if (/\.\d{2}$/.test(cleaned)) {
      return Math.round(parseFloat(cleaned.replace(/,/g, '')) * 100);
    }
    if (/,\d{2}$/.test(cleaned)) {
      return Math.round(parseFloat(cleaned.replace(/\./g, '').replace(',', '.')) * 100);
    }
    return parseInt(cleaned.replace(/[.,]/g, ''), 10) * 100;
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Ensures the strikethrough original-price element is present and correctly styled.
  // If Easy Bundles created gbbFooterOriginalTotalValue: recolor it.
  // If absent: create it with our pre-discount total and insert after the discounted element.
  function ensureOriginalDisplay(originalCents) {
    var valueContainer = document.querySelector('.gbbFooterTotalValueContainer');
    if (!valueContainer) return;

    var originalEl = valueContainer.querySelector('.' + ORIGINAL_CLASS);

    if (originalEl) {
      originalEl.style.color = ORIGINAL_COLOR;
    } else {
      var discountedEl = valueContainer.querySelector('.' + TOTAL_SELECTOR.slice(1));
      if (!discountedEl) return;
      var newEl = document.createElement('div');
      newEl.className = ORIGINAL_CLASS;
      newEl.dataset.mbCreated = 'true';
      newEl.style.color = ORIGINAL_COLOR;
      newEl.style.textDecoration = 'line-through';
      newEl.textContent = formatMoney(originalCents);
      discountedEl.insertAdjacentElement('afterend', newEl);
    }
  }

  setInterval(function () {
    // Grip: read price from listing before overwriting, cache in active currency
    GRIP_IDS.forEach(function (id) {
      var priceEl = document.querySelector(
        'div.gbbProductItem[productid="' + id + '"] .gbbProductItemPrice'
      );
      if (priceEl && priceEl.innerText !== 'Free!!') {
        var parsed = parseCents(priceEl.innerText);
        if (parsed > 0) gripDiscountCents = parsed;
        priceEl.innerText = 'Free!!';
      }
    });

    // Fleshlight: cache per product ID (overrides Liquid USD fallback with active-currency price)
    FLESHLIGHT_IDS.forEach(function (id) {
      var priceEl = document.querySelector(
        'div.gbbProductItem[productid="' + id + '"] .gbbProductItemPrice'
      );
      if (priceEl && priceEl.innerText !== 'Free!!') {
        var parsed = parseCents(priceEl.innerText);
        if (parsed > 0) fleshlightPriceCache[id] = parsed;
        priceEl.innerText = 'Free!!';
      }
    });

    // Cart total
    var totalEl = document.querySelector(TOTAL_SELECTOR);
    if (!totalEl) return;

    var gripInCart = !!getCartProductId(GRIP_IDS);
    var fleshlightIdInCart = getCartProductId(FLESHLIGHT_IDS);

    if (!gripInCart && !fleshlightIdInCart) {
      lastWrittenCents = null;
      lastOriginalCents = null;
      var ourEl = document.querySelector('.' + ORIGINAL_CLASS + '[data-mb-created]');
      if (ourEl) ourEl.remove();
      return;
    }

    var totalDiscount = 0;
    if (gripInCart) totalDiscount += gripDiscountCents || GRIP_FALLBACK_CENTS;
    if (fleshlightIdInCart) totalDiscount += fleshlightPriceCache[fleshlightIdInCart] || 0;
    if (totalDiscount === 0) return;

    var currentCents = parseCents(totalEl.textContent);
    if (isNaN(currentCents) || currentCents <= 0) return;

    if (currentCents !== lastWrittenCents) {
      lastOriginalCents = currentCents;
      var adjustedCents = Math.max(0, currentCents - totalDiscount);
      lastWrittenCents = adjustedCents;
      totalEl.textContent = formatMoney(adjustedCents);
    }

    // Always ensure original display is present — React re-renders may have removed it
    if (lastOriginalCents) ensureOriginalDisplay(lastOriginalCents);
  }, 250);
})();